var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("reference-layout", {
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("reference-header", {
              attrs: { "header-title": "Документы" },
              scopedSlots: _vm._u([
                {
                  key: "header-title-action",
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                },
                {
                  key: "header-actions",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "layout-header-action" },
                        [
                          _c("c-button-2", {
                            attrs: {
                              size: "small",
                              label: "Новый тип",
                              icon: {
                                icon: "plus",
                                color: "blue",
                              },
                            },
                            on: { click: _vm.createDocumentType },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "layout-header-action" },
                        [
                          _c("c-button-2", {
                            attrs: {
                              size: "small",
                              label: "Новый документ",
                              icon: {
                                icon: "plus",
                                color: "blue",
                              },
                            },
                            on: { click: _vm.createDocument },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "subheader",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "documents-page__search" },
              [
                _c("c-input", {
                  attrs: {
                    placeholder: "Поиск",
                    type: "text",
                    clearable: true,
                    icon: "search",
                  },
                  model: {
                    value: _vm.query,
                    callback: function ($$v) {
                      _vm.query = $$v
                    },
                    expression: "query",
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "list",
        fn: function () {
          return [
            _c("c-switcher", {
              staticClass: "h-switcher documents-switch",
              attrs: { items: _vm.documentsSwitchItems, type: "group" },
              model: {
                value: _vm.documentSelectedItem,
                callback: function ($$v) {
                  _vm.documentSelectedItem = $$v
                },
                expression: "documentSelectedItem",
              },
            }),
            _c("documents-list", {
              ref: "list",
              attrs: {
                query: _vm.query,
                "selected-tab": _vm.documentSelectedItem,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }